import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 240.97 152.94"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M83.18 152.94H0L157.79 0h83.18L83.18 152.94Z",
      style: {"fill":"#ffe600"}
    }, null, -1),
    _createElementVNode("path", { d: "M110.52 65.93c0-8.87-5.55-13.15-17.59-13.15h-9.19v45.96h5.07V79.41h3.64c1.27 0 2.54 0 3.64-.16l17.59 31.38.16.32h5.07v-.79l-18.07-31.69c6.5-2.06 9.67-6.18 9.67-12.52M92.77 76.39h-4.12v-20.6h4.12c8.87 0 12.52 3.01 12.52 10.14 0 7.29-3.64 10.46-12.52 10.46M149.71 74.49c4.91-1.58 7.61-5.23 7.61-10.46 0-7.61-5.23-11.25-16.16-11.25h-10.93v45.96h11.73c11.25 0 17.12-4.28 17.12-12.84 0-5.71-3.33-9.83-9.35-11.41m-14.44-18.7H141c7.92 0 11.25 2.54 11.25 8.56s-3.64 9.03-11.89 9.03h-5.07V55.79Zm5.7 39.93h-5.71V76.23h6.18c8.4 0 12.2 3.17 12.2 9.83s-3.96 9.67-12.68 9.67" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "BI-logo"}) } }